import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
declare var $: any;
import * as _ from 'lodash';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { EcsService } from 'src/app/services/ecs.service';
@Component({
  selector: 'app-ecslist',
  templateUrl: './ecslist.component.html',
  styleUrls: ['./ecslist.component.css']
})
export class EcslistComponent implements OnInit {

  public environmentSettings: any;
  isSearchDivVisible = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  // dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfEcs: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  deletebankdetails: any;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  // dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  currentURL: any;
  response: boolean;
  deleteEcsId: any;
  nameOfBank: string;
  ParticularId: any;
  dateOfBM: any;
  dateOfBMTo: any;
  

  constructor(private ecsService: EcsService, private router: Router, private commonFunction: CommonFunction,
    private alert: AlertComponent,private activatedRoute: ActivatedRoute) {
    this.response = false;
  }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');


    this.getRegisterDirectorList();

    this.dtOptionsOfEcs = {
      destroy: true,
      scrollY: "210px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Electronic Clearing Service (ECS)',
          title: 'Electronic Clearing Service (ECS)',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 4],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    // setTimeout(() => {
    //   $("#ecsListTable").DataTable().columns.adjust().draw();
    // }, 200);

    this.currentURL = window.location.href;


    var haseditpermisssion: any = false;
    if (this.currentURL.includes('edit') && !environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'edit');
    }
    else if (environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'add');
    }
    haseditpermisssion = false;

  }

  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['ecs','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if (directorData.length) {
      this.masterDirectorList = [];
      $("#directormasterbankTable").DataTable().destroy();
      this.masterDirectorList = directorData;
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#directormasterbankTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directormasterbankTable").DataTable().columns.adjust().draw();
    });
  }


  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.ecsService.getRegisterDirector({ isSearch: false }).subscribe(registerList => {
       
      $("#ecsListTable").DataTable().destroy();
      this.registerDirectorList = registerList.data;
       this.dtTriggerMasterDirector.next();
      // setTimeout(() => {
      //   this.dtTriggerMasterDirector.next();
      // }, 200);
    });
  }

  editEcsdetail(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['ecs','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['ecs/edit/', _id]);
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfBM,
      toDate: this. dateOfBMTo,
      name: this.nameOfBank
    }
    this.ecsService.generateEcsDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.ecsService.downloadEcsFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.ecsService.downloadEcsPdfFile(id, 'Multi');
  }
  confirmDelete(id) {
    this.deleteEcsId = id;
    $("#deleteConfirm").modal('toggle');
  }
  deleteInvestment() {
    this.ecsService.removeEcsdetails(this.deleteEcsId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#ecsListTable").DataTable().destroy();
          $('#deleteConfirm').modal('toggle');
        } else {
          this.alert.error(response.message);
        }
        this.getRegisterDirectorList();
      });

  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "nameOfBank": this.nameOfBank,
      "dateOfBM": this.setDate(this.dateOfBM),
      "dateOfBMTo": this.setDate(this.dateOfBMTo),
      'isSearch': true,
    };

    this.registerDirectorList = [];
    $("#ecsListTable").DataTable().destroy();
    this.ecsService.getRegisterDirector(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerMasterDirector.next();
    });
  }
  clearAdvSearch() {
    this.nameOfBank = '';
    this.dateOfBM = undefined;
    this.dateOfBMTo = undefined;
    $("#ecsListTable").DataTable().destroy();
    this.getRegisterDirectorList();
  }
}
